module.exports = __webpack_public_path__ + "static/media/notifShiftChange.640d3113.svg";